import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Mail } from "lucide-react";
import { Button } from "../components/ui/button";
import { Alert, AlertDescription } from "../components/ui/alert";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await axios.post(`${API_URL}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.message || "No se pudo procesar la solicitud");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center relative bg-gray-900 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center filter brightness-50"
        style={{ backgroundImage: "url('/login-bg.jpg')" }}
      />
      <div className="relative z-10 w-full max-w-md mx-4 p-10 bg-white/90 rounded-3xl shadow-2xl backdrop-blur-md">
        <div className="flex justify-center mb-6">
          <img
            src="/logo.png"
            alt="Previonix Logo"
            className="h-16 w-auto object-contain"
          />
        </div>
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-4">
          Recupera tu contraseña
        </h2>

        {sent ? (
          <>
            <p className="text-center text-gray-600 mb-8">
              Si el correo está registrado, recibirás un enlace para restablecer tu contraseña.
            </p>
            <Button
              className="w-full py-3 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-semibold transition"
              onClick={() => navigate("/login")}
            >
              Volver a iniciar sesión
            </Button>
          </>
        ) : (
          <>
            <p className="text-center text-gray-600 mb-8">
              Ingresa tu correo y te enviaremos un enlace para restablecerla.
            </p>
            <form onSubmit={handleSubmit} className="space-y-5">
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="email"
                  placeholder="Correo electrónico"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-300 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none transition bg-white/90"
                />
              </div>

              <Button
                type="submit"
                className="w-full py-3 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-semibold transition"
                disabled={loading}
              >
                {loading ? "Enviando..." : "Enviar enlace"}
              </Button>
            </form>

            {error && (
              <Alert type="error" className="mt-5">
                <AlertDescription>{error}</AlertDescription>
              </Alert>
            )}
          </>
        )}

        <div className="text-center mt-6">
          <button
            className="text-blue-600 hover:text-blue-800 font-semibold"
            onClick={() => navigate("/login")}
          >
            Volver a iniciar sesión
          </button>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
